import { createIntlScope } from '@txt/core/intl';
import { CoreUiI18nDE } from './de';
import { CoreUiI18nEN } from './en';

export const { FormattedMessage, formatMessage } = createIntlScope({
  en: CoreUiI18nEN,
  de: CoreUiI18nDE,
});
